import styled, { keyframes } from 'styled-components';

import CustomCheckbox from './CustomCheckbox';
import Switch from './Switch';

import Box from '../../../styles/Box';

const checkboxChecked = keyframes`
  50% {
      transform: scale(0.9);
  }
`;

export default styled.input.attrs(({ color }) => ({
  background: `var(--${color})`,
}))`
  display: none;

  + ${CustomCheckbox} {
    ${Box} {
      border-color: var(--text-color);
    }
  }

  &:checked {
    + ${CustomCheckbox} {
      ${Box} {
        background-color: ${props => props.background};
        border-color: ${props => props.background};
        animation: ${checkboxChecked} 0.4s ease;

        &::before {
          transform: scale(3.5);
          opacity: 0;
          transition: all 0.6s ease;
        }

        > svg {
          stroke-dashoffset: 0;
        }
      }
    }

    + ${Switch} {
      background-color: ${props => props.background};

      &:after {
        left: calc(100% - 3px);
        transform: translateX(-100%);
        background-color: var(--bg-color-light-gray);
      }
    }
  }
`;
